<!--
    @file:轨迹展示 父模块为 车辆定位 / 车辆追踪
    @props:{Arry} path 车辆的轨道信息
    @props:{String} action 巡航器的操作指令 stop start pause
    @props:{Number} speed 轨道巡航的速度
    @emit:{Number} percent 告诉父组件巡航器的巡航进度
-->
<template>
    <div id="amap-path" class="amap">
    </div>
</template>

<script>
import AMap from 'AMap';
import AMapUI from 'AMapUI';
export default {
    name: 'amap-path',
    created () {
        /**
         * nextTick 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
         * getAmapApi 加载异步组件 AMap
         * 初始化地图
         */
        this.$nextTick(function () {
            var self = this;
            this.getAmapApi().then(AMap => {
                self.map = new AMap.Map('amap-path', {
                    resizeEnable: true,
                    zoom: 10,
                    center: [116.480983, 40.0958]
                });
                self.map.setZoom(10);
                self.map.setCenter([116.39, 39.9]);
                AMapUI.load(['ui/misc/PathSimplifier'], function (PathSimplifier) {
                    if (!PathSimplifier.supportCanvas) {
                        alert('当前环境不支持 Canvas！');
                        return;
                    }
                    self.initPage(PathSimplifier);
                });
            });
        });
    },
    beforeDestroy () {
        /**
         * 组件销毁后需要销毁巡航器,巡航器使用的资源较大需要及时销毁
         *
         */
        if (this.navgtr) {
            this.navgtr.destroy();
        }
    },
    data () {
        return {
            pathSimplifierIns: {},
            pathSimplifier: {},
            mapData: false,
            pathSim: false,
            myData: [],
            navgtr: null,
            percent: 0,
            map: {},
            maxDistance: 0,
            carInfo: {}
        };
    },
    props: ['path', 'action', 'speed'],
    methods: {
        getAmapApi () {
            /**
             * 异步加载地图控件
             *
             */
            return new Promise(function (resolve, reject) {
                resolve(AMap);
            });
        },
        initPage (PathSimplifier) {
            /**
             * 初始化巡航器
             *
             */
            var self = this;
            var colors = [
                '#3366cc', '#dc3912', '#ff9900', '#109618', '#990099', '#0099c6', '#dd4477', '#66aa00',
                '#b82e2e', '#316395', '#994499', '#22aa99', '#aaaa11', '#6633cc', '#e67300', '#8b0707',
                '#651067', '#329262', '#5574a6', '#3b3eac'
            ];
            var pathSimplifierIns = new PathSimplifier({
                zIndex: 100,
                map: self.map, // 所属的地图实例

                getPath: function (pathData, pathIndex) {
                    return pathData.path;
                },
                getHoverTitle: function (pathData, pathIndex, pointIndex) {
                    if (pointIndex >= 0) {
                        // point
                        return '车辆：' + pathData.name + '/时间点：' + pathData.time[pointIndex];
                    }

                    return '车辆：' + pathData.name;
                },
                renderOptions: {
                    pathLineStyle: {
                        dirArrowStyle: true
                    },
                    getPathStyle: function (pathItem, zoom) {
                        var color = colors[pathItem.pathIndex % colors.length];
                        var lineWidth = Math.round(4 * Math.pow(1.1, zoom - 3));

                        return {
                            pathLineStyle: {
                                strokeStyle: color,
                                lineWidth: lineWidth
                            },
                            pathLineSelectedStyle: {
                                lineWidth: lineWidth + 2
                            },
                            pathNavigatorStyle: {
                                fillStyle: color
                            }
                        };
                    }
                }
            });
            self.pathSimplifierIns = pathSimplifierIns;
            self.pathSimplifier = PathSimplifier;
            self.pathSim = true;
        },
        formatPath (val) {
            /**
             * 遍历传送过来的数据,让数据格式符合巡航器所需数据格式
             *
             */
            var path = [];
            var time = [];
            val.path.forEach(function (item) {
                path.push(item.gps);
                time.push(item.time);
            });
            this.carInfo = val.car;
            return [{
                path: path,
                time: time,
                name: val.car.plate_number
            }];
        }
    },
    computed: {
        initData: function () {
            /**
             * 判断地图API加载完毕且父模板有数据
             *
             */
            return this.pathSim && this.mapData;
        }
    },
    watch: {
        path: {
            handler: function (val, oldVal) {
                this.myData = this.formatPath(val);
                this.mapData = !this.mapData;
            },
            deep: true
        },
        initData: function () {
            /**
             * 更新巡航器的轨道信息
             *
             */

            var self = this;
            self.pathSimplifierIns.setData(self.myData);
            // 如果已存在巡航.destroy
            if (self.navgtr) {
                self.map.remove(self.navgtr.marker);
                self.navgtr.destroy();
            }
            // init navgtr
            self.navgtr = self.pathSimplifierIns.createPathNavigator(0, {
                loop: true,
                pathNavigatorStyle: {
                    width: 16,
                    height: 32,
                    content: self.pathSimplifier.Render.Canvas.getImageContent('./static/img/car.png', onload, onerror),
                    strokeStyle: null,
                    fillStyle: null
                }
            });
            // init marker
            /* self.navgtr.marker = new AMap.Marker({
                offset: new AMap.Pixel(12, -10),
                content: '',
                map: self.map
            }); */
            function onload () {
                self.pathSimplifierIns.renderLater();
            }

            function onerror (e) {
                alert('图片加载失败！');
            }
            // 根据路径path的距离设定巡航器的速度
            self.navgtr.moveToPoint(self.navgtr.getPathEndIdx());
            self.maxDistance = self.navgtr.getMovedDistance();
            self.navgtr.setSpeed(self.speed * self.maxDistance / 50);

            // self.navgtr.on('start', function () {});
            // 当巡航器运动时实时传递巡航进度
            self.navgtr.on('move', function () {
                // this.marker.setPosition(this.getPosition());
                self.$emit('percent', Number((this.getMovedDistance() / self.maxDistance * 100).toFixed(2)));
            });
            // self.navgtr.on('stop', function () {});
            // this.navgtr.start();
        },
        action: function (val, oldVal) {
            /**
             * 父组件传递的巡航器的操作指令
             *
             */
            if (this.navgtr) {
                this.navgtr[val]();
            }
        },
        speed: function (val, oldVal) {
            /**
             * 设置巡航器的速度
             *
             */
            if (this.navgtr) {
                this.navgtr.setSpeed(val * this.maxDistance / 50);
            }
        }

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./map-style.css"></style>



// WEBPACK FOOTER //
// amap-path.vue?d3df397a